import { FC, useMemo } from "react";
import { useForm } from "react-hook-form";
import { TextField } from "@radix-ui/themes";
import { Button } from "@/components/button";
import { validationModule } from "@/modules/validation";
import styled from "@emotion/styled";

interface LookupByUuidFormProps {
  placeholder?: string;
  buttonLabel?: string;
  onSubmit: (uuid: string) => void;
}

interface FormData {
  uuid: string;
}

export const LookupByUuidForm: FC<LookupByUuidFormProps> = ({
  placeholder = "b2337ebe-8bc4-4954-aaeb-7692211445cd",
  buttonLabel = "View",
  onSubmit,
}) => {
  const { register, handleSubmit, watch } = useForm<FormData>();
  const uuid = watch("uuid");

  const isValidInput = useMemo(() => {
    return validationModule.isUuid(uuid);
  }, [uuid]);

  const handleFormSubmit = (data: FormData) => {
    const trimmed = data.uuid.trim();
    if (!trimmed) return;
    onSubmit(trimmed);
  };

  return (
    <FormContainer onSubmit={handleSubmit(handleFormSubmit)}>
      <TextField.Root
        placeholder={placeholder}
        maxLength={36}
        {...register("uuid", { required: true })}
      />
      <Button type="submit" disabled={!isValidInput}>
        {buttonLabel}
      </Button>
    </FormContainer>
  );
};

const FormContainer = styled.form`
  width: 100%;
  min-width: 320px;
`;
